import {Vue, Component} from "vue-property-decorator";

@Component
class Spinner extends Vue {

  render() {
    return (
      <span class="spinner">
        <div class="loader" />
      </span>
    );
  }
}

export {Spinner}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-06950863/spinner.tsx" });